// eslint-disable-next-line strict
'use strict';

const { nth } = require('lodash');

if (!Array.prototype.at) {

    // eslint-disable-next-line no-extend-native, strict
    Array.prototype.at = function (index) {

        return nth(this, index);
    };
}
